module.exports = __webpack_public_path__ + "static/media/volumetric-clouds-cloudscapes.483e8554.png";